import { z } from "zod";
import { Id } from "./common";
import { defineRoutes } from "./define";
import { PROBLEMS } from "./problem";

const Pain = z.number().int().min(0).max(10);

/** Mirrors core/shared/ai/structured-visit-draft.ts — the same shape the visit form edits. */
export const StructuredVisitDraft = z.object({
  summary: z.string(),
  painBefore: Pain.nullable(),
  painAfter: Pain.nullable(),
  done: z.string(),
  worked: z.string(),
  notWorked: z.string(),
  reaction: z.string(),
  checkNext: z.string(),
  nextPlan: z.string(),
  homework: z.string(),
  write24: z.boolean(),
  patientMessage: z.string(),
  coachSummary: z.string(),
});
export type StructuredVisitDraft = z.infer<typeof StructuredVisitDraft>;

export const StructureNoteBody = z.object({
  raw: z.string().trim().min(1, "Порожня нотатка").max(6000, "Нотатка занадто довга"),
  episodeId: Id,
});
export type StructureNoteBody = z.infer<typeof StructureNoteBody>;

export const ai = defineRoutes({
  structureNote: {
    method: "POST",
    path: "/ai/structure-note",
    summary: "Turn a raw specialist note into a structured visit draft",
    body: StructureNoteBody,
    responses: {
      200: StructuredVisitDraft,
      400: PROBLEMS[400],
      401: PROBLEMS[401],
      403: PROBLEMS[403],
      404: PROBLEMS[404],
      422: PROBLEMS[422],
    },
  },
});
